import KOGImage from "@/main/components/shared/kogImage/kogImage";

//SCREENS/COMPONENTS/STYLES LOCAL
import * as S from "./styles";
import { QuoteProcurementPartInfoResponse } from "@/main/models/response";
import QuoteProcurementPartInfo from "@/main/components/shared/quoteProcurementPartInfo/quoteProcurementPartInfo";

interface IPartComponent {
	image: string;
	quoteProcurementPartInfo: QuoteProcurementPartInfoResponse;
	quantity: number;
}

function PartComponent({ image, quoteProcurementPartInfo, quantity }: IPartComponent) {
	return (
		<>
			<S.ImagePartComponent>
				<KOGImage src={image} />
			</S.ImagePartComponent>
			<S.ContainerQuantityWithPart>
				<QuoteProcurementPartInfo data={quoteProcurementPartInfo} renderType="column" />
				{quantity && quantity > 0 && <S.CountParts>{quantity}</S.CountParts>}
			</S.ContainerQuantityWithPart>
		</>
	);
}

export default PartComponent;
